import { render, staticRenderFns } from "./platform_invoice_statuses.vue?vue&type=template&id=0be3ee51&scoped=true&"
import script from "./platform_invoice_statuses.vue?vue&type=script&lang=js&"
export * from "./platform_invoice_statuses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be3ee51",
  null
  
)

export default component.exports